import styled from 'styled-components'

const BaseSelectBox = styled.select`
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  line-height: 1.2em;
  padding: 0.7em 2em 0.7em 1em;
  vertical-align: top;
  width: 100%;

  &::-ms-expand {
    display: none;
  }

  &:hover {
    background-color: #fff1f1;
  }
`

export default BaseSelectBox
